import SV from './cities.sv.json';
import I18N from './cities.i18n.json';

// URL pattern per language: keyword + city in the language people search in
const SLUG = {
  sv: (c) => `/korkortsteori-${c}`,
  en: (c) => `/en/driving-theory-${c}`,
  ar: (c) => `/ar/teori-alqiyada-${c}`,
  tr: (c) => `/tr/ehliyet-teorisi-${c}`,
  fa: (c) => `/fa/teori-ranandegi-${c}`,
  so: (c) => `/so/aragtida-wadista-${c}`,
  pl: (c) => `/pl/teoria-prawo-jazdy-${c}`,
  es: (c) => `/es/teoria-conducir-${c}`,
  de: (c) => `/de/fahrtheorie-${c}`,
};

const OFFICE_TITLE = {
  sv: 'Var görs proven?', en: 'Where are the tests held?', ar: 'أين تُقام الامتحانات؟', tr: 'Sınavlar nerede yapılıyor?',
  fa: 'آزمون‌ها کجا برگزار می‌شوند؟', so: 'Xagee lagu qaadaa imtixaannada?', pl: 'Gdzie odbywają się egzaminy?',
  es: '¿Dónde se hacen los exámenes?', de: 'Wo finden die Prüfungen statt?',
};

const content = (key, lang) => (lang === 'sv' ? SV[key] : I18N[key]?.[lang]);

export const CITY_PAGES = {};
export const CITY_ROUTES = [];

Object.keys(SV).forEach((key) => {
  const langLinks = {};
  Object.keys(SLUG).forEach((lang) => { if (content(key, lang)) langLinks[lang] = SLUG[lang](key); });
  Object.entries(langLinks).forEach(([lang, path]) => {
    const c = content(key, lang);
    const others = Object.keys(SV).filter((k) => k !== key).slice(0, 4);
    CITY_PAGES[path] = {
      lang,
      city: c.city,
      title: c.title,
      description: c.description,
      h1: c.h1,
      intro: [c.intro],
      sections: [[OFFICE_TITLE[lang], c.office], ...c.sections],
      faq: c.faq,
      langLinks,
      related: others.map((k) => SLUG[lang](k)).filter((p) => content(p.split('-').slice(-1)[0], lang) !== undefined),
      relatedLabels: Object.fromEntries(others.map((k) => [SLUG[lang](k), content(k, lang)?.city || SV[k].city])),
    };
    CITY_ROUTES.push(path);
  });
});
